export default "__VITE_ASSET__Cjhl_Jn5__"